<div class="caption-bar">
  <div class="caption">{{ "machinery.title" | translate }}</div>
  @if(state.userHasMinType(1)){
  <ion-button (click)="openContextMenu($event)">
    <ion-icon size="large" name="add"></ion-icon>
  </ion-button>
  }
</div>

<lib-machinery-overview></lib-machinery-overview>
